/*
 * It's Time storefront widgets: the Events list and the Google reviews carousel.
 * Replaced the Elfsight embeds on 14 Oct 2026. Data comes from the app's cached
 * public feeds (itstime/api/storefront_public.py); a page view never calls Google.
 *
 *   a div.itw-events (optional data-limit, default 10) or a div.itw-reviews,
 *   then this file as a deferred script tag via {{ 'itstime-widgets.js' | asset_url }}
 *
 * Optional data-api="https://..." on either element points at another app host.
 * All text goes in with textContent; nothing from the feeds is parsed as HTML.
 */
(function () {
  'use strict';
  if (window.__itwLoaded) return;
  window.__itwLoaded = true;

  var API = 'https://itstimecards.ai';
  var ZONE = 'America/Los_Angeles';
  var STORE = {
    name: "IT'S TIME! Sports Cards, TCG & eSports",
    street: '29360 Roadside Dr', city: 'Agoura Hills', region: 'CA', zip: '91301', country: 'US',
    url: 'https://itstimecards.com'
  };

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function safeUrl(value) {
    return typeof value === 'string' && value.indexOf('https://') === 0 ? value : '';
  }

  function load(root, path) {
    var base = safeUrl(root.getAttribute('data-api')) || API;
    return fetch(base + path, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  // ---------------------------------------------------------------- dates

  function parts(iso) {
    var out = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: ZONE, year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit'
    }).formatToParts(new Date(iso)).forEach(function (p) { out[p.type] = p.value; });
    return out;
  }

  function dayKey(p) { return p.year + '-' + p.month + '-' + p.day; }
  function clock(p) { return p.hour + ':' + p.minute + ' ' + p.dayPeriod; }
  function shortDate(p) { return p.month + ' ' + p.day; }

  function when(ev) {
    var s = parts(ev.starts_at), e;
    if (ev.all_day) {
      // All-day ends are exclusive: the last day shown is the day before.
      e = parts(new Date(new Date(ev.ends_at).getTime() - 1).toISOString());
      return dayKey(s) === dayKey(e) ? 'All day' : shortDate(s) + ' – ' + shortDate(e);
    }
    e = parts(ev.ends_at);
    var hours = (new Date(ev.ends_at) - new Date(ev.starts_at)) / 3600000;
    if (dayKey(s) === dayKey(e) || hours < 24) return clock(s) + ' – ' + clock(e);
    return shortDate(s) + ', ' + clock(s) + ' – ' + shortDate(e) + ', ' + clock(e);
  }

  // ---------------------------------------------------------------- events

  var CLOCK = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="7" fill="currentColor"/>' +
    '<path d="M8 4.5V8l2.5 1.5" stroke="#e8e8e8" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>';

  function card(ev) {
    var s = parts(ev.starts_at);
    var hasMore = !!ev.description;
    var item = el('li', 'itw-event');
    item.id = 'event-' + ev.id;
    var box = el(hasMore ? 'details' : 'div', 'itw-card');
    var head = el(hasMore ? 'summary' : 'div', 'itw-head');
    var date = el('div', 'itw-date');
    date.appendChild(el('span', 'itw-month', s.month.toUpperCase()));
    date.appendChild(el('span', 'itw-day', s.day));
    var body = el('div', 'itw-body');
    body.appendChild(el('h3', 'itw-title', ev.title));
    var time = el('span', 'itw-time');
    time.innerHTML = CLOCK;
    time.appendChild(document.createTextNode(when(ev)));
    body.appendChild(time);
    head.appendChild(date);
    head.appendChild(body);
    if (hasMore) head.appendChild(el('span', 'itw-chevron'));
    box.appendChild(head);
    if (hasMore) box.appendChild(el('p', 'itw-desc', ev.description));
    item.appendChild(box);
    return item;
  }

  function schema(events) {
    if (document.getElementById('itw-events-schema') || !events.length) return;
    var tag = document.createElement('script');
    tag.type = 'application/ld+json';
    tag.id = 'itw-events-schema';
    tag.textContent = JSON.stringify(events.slice(0, 50).map(function (ev) {
      var item = {
        '@context': 'https://schema.org', '@type': 'Event', name: ev.title,
        startDate: ev.all_day ? ev.starts_at.slice(0, 10) : ev.starts_at,
        endDate: ev.all_day ? ev.ends_at.slice(0, 10) : ev.ends_at,
        eventStatus: 'https://schema.org/EventScheduled',
        eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
        location: { '@type': 'Place', name: STORE.name, address: {
          '@type': 'PostalAddress', streetAddress: STORE.street, addressLocality: STORE.city,
          addressRegion: STORE.region, postalCode: STORE.zip, addressCountry: STORE.country } },
        organizer: { '@type': 'Organization', name: STORE.name, url: STORE.url }
      };
      if (ev.description) item.description = ev.description;
      return item;
    })).replace(/</g, '\\u003c');
    document.head.appendChild(tag);
  }

  function openFromHash(root) {
    var id = decodeURIComponent((location.hash || '').slice(1));
    if (id.indexOf('event-') !== 0) return false;
    var item = document.getElementById(id);
    if (!item || !root.contains(item)) return false;
    var details = item.querySelector('details');
    if (details) details.open = true;
    item.scrollIntoView({ block: 'center' });
    return true;
  }

  function events(root) {
    var limit = Math.max(1, parseInt(root.getAttribute('data-limit'), 10) || 10);
    var status = el('p', 'itw-status', 'Loading events…');
    root.appendChild(status);
    load(root, '/api/public/store-events').then(function (data) {
      var all = (data && data.events) || [];
      if (!data.ok) throw new Error('not ready');
      schema(all);
      if (!all.length) { status.textContent = 'No upcoming events right now. Check back soon.'; return; }
      root.removeChild(status);
      var list = el('ul', 'itw-list');
      root.appendChild(list);
      var shown = 0;
      var more = el('button', 'itw-more', 'More events');
      more.type = 'button';
      function show(count) {
        all.slice(shown, shown + count).forEach(function (ev) { list.appendChild(card(ev)); });
        shown = Math.min(all.length, shown + count);
        more.hidden = shown >= all.length;
      }
      more.addEventListener('click', function () { show(limit); });
      root.appendChild(more);
      show(limit);
      // A link to one event (Home's card, a shared link) opens it, even past the first page.
      function reveal() {
        var id = (location.hash || '').slice(7);
        var at = -1;
        all.forEach(function (ev, i) { if (ev.id === id) at = i; });
        if (at >= shown) show(at - shown + 1);
        openFromHash(root);
      }
      reveal();
      window.addEventListener('hashchange', reveal);
    }).catch(function () {
      status.textContent = 'Events couldn’t load. Please refresh or call the store.';
    });
  }

  // ---------------------------------------------------------------- reviews

  function stars(n) {
    var full = Math.round(n);
    var s = el('span', 'itw-stars');
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', n + ' out of 5 stars');
    s.textContent = '★★★★★'.slice(0, full) + '☆☆☆☆☆'.slice(0, 5 - full);
    return s;
  }

  function link(text, href, cls) {
    var a = el('a', cls, text);
    a.href = href;
    a.target = '_blank';
    a.rel = 'noopener';
    return a;
  }

  function reviews(root) {
    load(root, '/api/public/store-reviews').then(function (data) {
      if (!data || !data.ok) return;
      var head = el('div', 'itw-rev-head');
      head.appendChild(el('span', 'itw-score', data.rating.toFixed(1)));
      head.appendChild(stars(data.rating));
      var mapsUrl = safeUrl(data.maps_url);
      var count = data.count.toLocaleString('en-US') + ' Google reviews';
      head.appendChild(mapsUrl ? link(count, mapsUrl, 'itw-count') : el('span', 'itw-count', count));
      if (safeUrl(data.write_url)) head.appendChild(link('Write a Review', data.write_url, 'itw-write'));
      root.appendChild(head);

      var frame = el('div', 'itw-frame');
      var track = el('ul', 'itw-track');
      (data.reviews || []).forEach(function (r) {
        var item = el('li', 'itw-review');
        item.appendChild(stars(r.rating));
        var text = el('p', 'itw-text', r.text);
        item.appendChild(text);
        if (safeUrl(r.url)) {
          var more = link('Read more', r.url, 'itw-readmore');
          more.hidden = true;
          item.appendChild(more);
          item._more = more;
          item._text = text;
        }
        var by = el('div', 'itw-by');
        by.appendChild(safeUrl(r.author_url) ? link(r.author, r.author_url, 'itw-author') : el('span', 'itw-author', r.author));
        if (r.when) by.appendChild(el('span', 'itw-when', r.when));
        item.appendChild(by);
        track.appendChild(item);
      });
      frame.appendChild(track);
      var prev = el('button', 'itw-arrow itw-prev');
      var next = el('button', 'itw-arrow itw-next');
      prev.type = next.type = 'button';
      prev.setAttribute('aria-label', 'Previous reviews');
      next.setAttribute('aria-label', 'Next reviews');
      frame.appendChild(prev);
      frame.appendChild(next);
      root.appendChild(frame);
      var credit = el('p', 'itw-credit', 'Reviews from Google Maps');
      root.appendChild(credit);

      function step(dir) {
        var first = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: dir * (first ? first.getBoundingClientRect().width + gap : track.clientWidth), behavior: 'smooth' });
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= max - 2;
        Array.prototype.forEach.call(track.children, function (item) {
          if (item._more) item._more.hidden = item._text.scrollHeight <= item._text.clientHeight + 1;
        });
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }).catch(function () { /* the intro text above stays; no empty frame */ });
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.itw-events'), function (root) {
      if (!root.__itw) { root.__itw = true; events(root); }
    });
    Array.prototype.forEach.call(document.querySelectorAll('.itw-reviews'), function (root) {
      if (!root.__itw) { root.__itw = true; reviews(root); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // The theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', start);
})();
